let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gDg0T")).then(() => parcelRequire('4cbUQ'));